import type { ResponsesKey } from '../components/SurveyResponsesPanel';
import { SURVEY_STATUS, type Survey } from '../surveyTypes';

export type TabKey = 'info' | 'configuration' | 'responses' | 'plan';

/** The folder tabs inside Configuration — a second strip, below the profile's own. */
export type ConfigurationKey = 'questionnaire';

/**
 * Where a survey's profile opens — the next thing to do with it, in the survey's own order:
 *
 * 1. nothing to answer yet        → Configuration › Questionnaire, to build it
 * 2. built, not started           → Configuration › Questionnaire, whose cog starts it
 * 3. responses not yet assessed   → Responses › Assessment, to assess them
 * 4. every response assessed      → Development Plan
 * 5. open and waiting for answers → Configuration › Questionnaire, whose cog ends it
 *
 * A DELETED survey has nothing to do next, so it opens on Info. Every figure is the server's.
 */
export function nextAction(survey: Survey): { tab: TabKey; configuration: ConfigurationKey; responses: ResponsesKey } {
  const at = (tab: TabKey, configuration: ConfigurationKey = 'questionnaire', responses: ResponsesKey = 'summary') => ({
    tab,
    configuration,
    responses,
  });

  if (!survey.isActive) return at('info');
  if (survey.questionCount === 0) return at('configuration', 'questionnaire');
  if (survey.status === SURVEY_STATUS.NotStarted) return at('configuration');
  if (survey.respondentCount > survey.assessedCount) return at('responses', 'questionnaire', 'individual');
  if (survey.assessedCount > 0) return at('plan');

  return at('configuration');
}
